import { type ReactNode } from 'react';

// Issue #550: Page shell — header padrao das paginas autenticadas.
// Padrao consolidado a partir das "paginas boas" da auditoria de layout
// (Documents/Team): wrapper space-y-6 + header flex (h1 + subtitulo a
// esquerda, slot de acoes a direita) + children. O <main> do Layout ja
// fornece o container (max-w-6xl px-4 py-8) — as paginas NAO repetem
// wrapper proprio (max-w-*/px-4/py-8 duplicado).

interface PageProps {
  /** Titulo da pagina (h1). */
  title: string;
  /** Subtitulo opcional, exibido abaixo do titulo. */
  subtitle?: string;
  /** Slot de acoes no canto direito do header (botoes, badges, filtros). */
  actions?: ReactNode;
  children: ReactNode;
}

function Page({ title, subtitle, actions, children }: PageProps) {
  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-brand-900">{title}</h1>
          {subtitle && <p className="text-sm text-brand-600">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {children}
    </div>
  );
}

export default Page;
